import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ role, redirectTo, children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-brand-navy">
        <div className="font-display text-2xl">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to={redirectTo || "/login/owner"} replace />;
  if (role && user.role !== role && user.role !== "admin") {
    return <Navigate to={redirectTo || "/"} replace />;
  }
  return children;
}
